<div *ngFor="let section of sections">
  <div [innerHTML]="section.body | mdToHtml"></div>
  <div [innerHTML]="section.subBody || '' | mdToHtml"></div>
</div>
